<template>
  <div class="copay-epa-source-filter-list">
    <b-table
      striped
      hover
      :fields="gridFields"
      :busy="busy"
      :items="searchResults.results"
      :per-page="size"
      :current-page="currentPage"
      @sort-changed="changeSorting"
      :sort:by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <div slot="table-busy" class="text-center my-2">
        <i class="fa fa-spinner fa-pulse"></i>
        <strong>Working...</strong>
      </div>
      <template slot="brand_limitation_text" slot-scope="data">
        <div v-if="isAdmin && getEffectiveStatus(data.item) !== 'deleted'">
          <router-link
            :to="{ name: 'brand-limit-item', params: { brand_limit_id: data.item.brand_limit_id, viewActive: false }}"
          >{{data.value}}</router-link>
        </div>
        <span v-if="(!isAdmin && isApprover) || getEffectiveStatus(data.item) === 'deleted'">{{data.value}}</span>
        <div v-if="(!isAdmin && isApprover) && getEffectiveStatus(data.item) !== 'new'">
          <a href @click.prevent="$emit('view-active', data.item)">View Published</a>
        </div>
      </template>
      <template slot="percent_used" slot-scope="data">
        <div v-if="!data.item.offer_unlimited_flag && data.item.brand_count_num > 0">
          <b-progress :max=data.item.upper_limit_num style="height: 2rem;background-color: #BEC0C2!important;">
            <b-progress-bar
              style="font-size: .9rem!important;"
              :value="Number(data.item.brand_count_num)"
              :label-html="`${((data.item.brand_count_num/data.item.upper_limit_num) * 100).toFixed(0)}%`">
            </b-progress-bar>
          </b-progress>
          <div class="progress-label">{{ data.item.brand_count_num.toLocaleString() }} of {{ data.item.upper_limit_num.toLocaleString() }}</div>
        </div>
        <div v-if="!data.item.offer_unlimited_flag && data.item.brand_count_num === 0">
          <b-progress :max=data.item.upper_limit_num style="height: 2rem;background-color: #BEC0C2!important;">
            <b-progress-bar
              style="font-size: .9rem!important;color: #000;margin-left: 6px;"
              :value="Number(data.item.brand_count_num)"
              :label-html="`0%`">
            </b-progress-bar>
          </b-progress>
          <div class="progress-label">{{ data.item.brand_count_num.toLocaleString() }} of {{ data.item.upper_limit_num.toLocaleString() }}</div>
        </div>
        <div v-if="data.item.offer_unlimited_flag">
          <div class="progress-label">{{ data.item.brand_count_num.toLocaleString() }} of unlimited</div>
        </div>
      </template>
      <template slot="copay_offers" slot-scope="data">
        <div v-for="item in data.value" :key="item">
        <span v-if="item.copay_offer_name">
        {{item.copay_offer_name}} ({{item.manufacture_name}})
        </span>
        </div>
      </template>
      <template slot="current_status" slot-scope="data">
        {{ data.value | snakeToTitleCase}}
      </template>
      <template slot="brand_limit_status_text" slot-scope="data">
        {{ data.value | snakeToTitleCase}}
      </template>
      <template slot="actions" slot-scope="data">
        <div v-if="(isAdmin || isApprover) && data.item.brand_limit_status_text === 'pending_approval'">
          <router-link
            :to="{ name: 'brand-limit-item', params: { brand_limit_id: data.item.brand_limit_id, brand_limit_status_text: data.item.brand_limit_status_text }}"
          >View for Approval</router-link>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item) !== 'new' && data.item.brand_limit_status_text === 'edit'">
          <a href @click.prevent="$emit('view-active', data.item)">View Published</a>
        </div>
        <div v-if="isAdmin && (data.item.brand_limit_status_text === 'edit' || data.item.brand_limit_status_text === 'new' || data.item.brand_limit_status_text === 'denied')">
          <a href @click.prevent="$emit('request-approval', data.item)">Request Approval</a>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item) === 'new' && (data.item.brand_limit_status_text === 'new' || data.item.brand_limit_status_text === 'edit' || data.item.brand_limit_status_text === 'pending_approval')">
          <a href @click.prevent="$emit('cancel-update', data.item)">Delete</a>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item) !== 'new' && data.item.brand_limit_status_text === 'pending_approval'">
          <a href @click.prevent="$emit('cancel-update', data.item)">Cancel Approval Request</a>
        </div>
        <div v-if="isAdmin && getEffectiveStatus(data.item) !== 'new' && data.item.brand_limit_status_text === 'edit'">
          <a href @click.prevent="$emit('cancel-update', data.item)">Cancel Edit</a>
        </div>
        <div v-if="isApprover && data.item.brand_limit_status_text === 'pending_approval'">
          <a href @click.prevent="$emit('approve', data.item)">Approve</a>
        </div>
        <div v-if="isApprover && data.item.brand_limit_status_text === 'approved'">
          <a href @click.prevent="$emit('publish', data.item)">Publish</a>
        </div>
      </template>
    </b-table>
    <b-pagination
      align="center"
      :total-rows="searchResults.total"
      :per-page="size"
      v-model="currentPage"
      @input="changePage"
    ></b-pagination>
  </div>
</template>
<script>
export default {
  name: "VBrandLimitList",
  data() {
    return {
      sortBy: "brand_limitation_text",
      sortDesc: false
    };
  },
  props: {
    searchResults: {
      required: true,
      type: Object
    },
    busy: {
      required: false,
      type: Boolean
    },
    isAdmin: {
      required: false,
      type: Boolean
    },
    isApprover: {
      required: false,
      type: Boolean
    },
    size: {
      required: false,
      type: Number
    },
    currentPage: {
      required: false,
      type: Number
    }
  },
  computed: {
    gridFields: {
      get() {
        let fields = [];
        fields.push({key: "brand_limitation_text", class: "id-field", label: "Title", sortable: true});
        fields.push({key: "percent_used", class: "default-field", label: "Percent Used", sortable: false});
        fields.push({key: "copay_offers", class: "offer-list-field", label: "Offers", sortable: false});
        fields.push({key: "current_status", class: "status-field", label: "Current Status", sortable: true});
        fields.push({key: "brand_limit_status_text", class: "status-field", label: "Workflow Status", sortable: true});
        fields.push({key: "actions", class: "action-field", label: "", sortable: false});
        return fields;
      }
    }
  },
  methods: {
    getEffectiveStatus(item) {
      return item.brand_limit_status_text;
    },
    changePage(page) {
      this.currentPage = page;
    },
    changeSorting(ctx) {
      this.sortDesc = ctx.sortDesc;
      this.sortBy = ctx.sortBy;
    }
  }
};
</script>
<style lang="scss">
.copay-epa-source-filter-list {
  .id-field {
    width: 200px;
  }
  .offer-list-field {
    width: 300px;
  }
  .default-field {
    width: 200px;
  }
  .status-field {
    width: 150px;
  }
  .action-field {
    width: 200px;
  }
}
.progress-label {
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/VBrandLimitList.vue